export const applicationLanguages = [
  { label: "🇺🇸 English (United States)", country: "USA" },
  { label: "🇦🇷 Español (Argentina)", country: "ARG" },
  { label: "🇧🇴 Español (Bolivia)", country: "BOL" },
  { label: "🇨🇱 Español (Chile)", country: "CHL" },
  { label: "🇨🇴 Español (Colombia)", country: "COL" },
  { label: "🇪🇨 Español (Ecuador)", country: "ECU" },
  { label: "🇪🇸 Español (España)", country: "ESP" },
  { label: "🇲🇽 Español (México)", country: "MEX" },
  { label: "🇵🇪 Español (Perú)", country: "PER" },
  { label: "🇵🇷 Español (Puerto Rico)", country: "PRI" },
  { label: "🇺🇾 Español (Uruguay)", country: "URY" },
  { label: "🇻🇪 Español (Venezuela)", country: "VEN" },
  { label: "🇧🇷 Portugues (Brasil)", country: "BRA" }
];
